/**
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * @param  {} aCardTemplate
 * @param  {} aCallBack
 * @param  {} aCallBackParameter1
 * @param  {} aCallBackParameter2
 * @example 
 * lCorrelateCardViewControl = new VeritracksCorrelateControl("CorrelateControl", "uAssociationsListPanel", null, "Interface/Enrollees.Offenders.Correlation.Popup.Layout.htm", populateMapEnrolleeCorrelateData, aParams);
 * lCorrelateCardViewControl.setDataSource(lCorrelateControl);
 */
var VeritracksCorrelateControl = function (aId, aParentId, aOptions, aCardTemplate, aCallBack, aCallBackParameter1, aCallBackParameter2) {
    "use strict";
    var mThis = this,
        mCardTemplateName = '',
        mCardTemplate = '',
        mIsDirty = true,
        mDataSource = [],
        mIsInitialized = false,
        mOptions = '',
        mCurrentTabIndex = 0,
        mCardDisplayLimit = 5,
        mCurrentCount = 0,
        mCurrentTabCount = 1,
        mCurrentTab = '', 
        mCallBack = null,
        mCallBackPar1 = null,
        mCallBackPar2 = null;
    

    VeritracksCorrelateControl.prototype.baseClass.call(this, aId, aParentId, '<div id="' + aId + '"></div>');

    if (!isNullOrUndefined(aCardTemplate)) {
        mCardTemplateName = aCardTemplate;
    }

    if (!isNullOrUndefined(aOptions)) {
        mCardDisplayLimit = aOptions.CardDisplayLimit;
    }
   
    if (!isNullOrUndefined(aCallBack)) {
        mCallBack = aCallBack;
    }

    if (!isNullOrUndefined(aCallBackParameter1)) {
        mCallBackPar1 = aCallBackParameter1;
    }

    if (!isNullOrUndefined(aCallBackParameter2)) {
        mCallBackPar2 = aCallBackParameter2;
    }

    function onInitialize() {
        bindDataToTemplate(mCardTemplate, mDataSource);
    }

    function loadTemplateSuccess(responseText, textStatus, XMLHttpRequest) {
        mCardTemplate = responseText;
        mIsInitialized = true;
        if (!isNullOrUndefined(mThis)) {
            mThis.trigger('initialized');
        }
        veritracks.localization.localize('#' + mThis.ParentId);
        mCallBack(mCallBackPar1);
    }

    function loadTemplateHtml() {
        $.get(mCardTemplateName, loadTemplateSuccess);
    }

    function bindDataToHeaderTemplate(aString, aItem) {
        var lHtml = [],
            lCount = 1,
            lDupEnrollees = [],
            lEnrollees = null;
        

        if (!isNullOrUndefined(aItem.enrolleeCorrelations)) {
            for (var key in aItem.enrolleeCorrelations) {
                if (aItem.enrolleeCorrelations.hasOwnProperty(key)) {
                    lEnrollees = getDataById(aItem.enrolleeCorrelations[key].MatchEnrolleeId, 'Enrollees');

                    if (lEnrollees == null) {
                        continue;
                    }

                    if (lDupEnrollees.indexOf(lEnrollees.Id) != -1) {
                        continue;
                    }

                    lDupEnrollees.push(lEnrollees.Id);


                    //if (lCount > mCardDisplayLimit) {
                     //   break;
                    //}

                    if (lCount == 1 && mCurrentTab == '') {
                        lHtml.push('<div id="uEnrolleeCorrelateTab' + aItem.enrolleeCorrelations[key].MatchEnrolleeId + '" class="MasterTab CorrelationTab Clickable Selected" onclick="navigateToNewCorrelation(' + aItem.enrolleeCorrelations[key].MatchEnrolleeId + ');" ItemKey="' + lCount + '">');
                        lHtml.push('<span class="CorrelationTabName">' + lEnrollees.FullName + '</span>');
                        lHtml.push('</div>');                        
                        if (mCurrentTab == '') {
                            mCurrentTab = 'uEnrolleeCorrelateTab' + aItem.enrolleeCorrelations[key].MatchEnrolleeId
                        }
                    } else {
                        if (mCurrentTab == 'uEnrolleeCorrelateTab' + aItem.enrolleeCorrelations[key].MatchEnrolleeId) {
                            lHtml.push('<div id="uEnrolleeCorrelateTab' + aItem.enrolleeCorrelations[key].MatchEnrolleeId + '" class="MasterTab CorrelationTab Clickable Selected" onclick="navigateToNewCorrelation(' + aItem.enrolleeCorrelations[key].MatchEnrolleeId + ');" ItemKey="' + lCount + '">');
                            lHtml.push('<span class="CorrelationTabName">' + lEnrollees.FullName + '</span>');
                            lHtml.push('</div>');
                        } else {
                            lHtml.push('<div id="uEnrolleeCorrelateTab' + aItem.enrolleeCorrelations[key].MatchEnrolleeId + '" class="MasterTab CorrelationTab Clickable" onclick="navigateToNewCorrelation(' + aItem.enrolleeCorrelations[key].MatchEnrolleeId + ');" ItemKey="' + lCount + '">');
                            lHtml.push('<span class="CorrelationTabName">' + lEnrollees.FullName + '</span>');
                            lHtml.push('</div>');
                        }  
                    }
                    lCount++;
                    mCurrentCount = lCount;
                }//end of if
            }//end of for
        }//end of if

        $('#EnrolleeCorrelationHeaderPanelHolder').append(lHtml.join(''));        
    }

    function bindDataToTemplate(aString, aItem) {
        var lSearch = '',
            aIndex = -1;
            
        for (var key in aItem) {
            lSearch = "##" + key + "##";
            aIndex = aString.search(lSearch);
            if (aIndex != -1) {
                aString = aString.replace(lSearch, aItem[key]);
            }//end of if
        }//end of for

        mThis.ControlElement.html(aString);
        bindDataToHeaderTemplate(aString, mDataSource);
      
    }    

    function dataBind() {
        
        if (mIsInitialized) {
            mThis.unbind('initialized', onInitialize);
        }
        mThis.bind('initialized', onInitialize);
        

        loadTemplateHtml();
    }

    function getDataById(aId, aType) {
        var lResult = null;
        lResult = getDataItem(aId, aType);
        if (lResult == null && CheckUserHasPermission(45)) {
            lResult = getDataItem(aId, aType + 'Universal');
        }
        return lResult;
    }

    this.setDataSource = function (aDataSource) {
        mDataSource = aDataSource;
        mIsDirty = true;
        if (!this.isNothing(mCardTemplate) && !this.isNothing(mDataSource)) {
            dataBind();
        }
    };

    this.getDataSource = function () {
        return mDataSource;
    }

    this.dispose = function () {
        mThis.unbind('initialized', onInitialize);
        mDataSource = null;
        mThis = null;
        mCardTemplateName = '';
        mCardTemplate = '',
        mIsDirty = true,
        mDataSource = [],
        mIsInitialized = false,
        mOptions = '';
        mCurrentTab = '';
        mCurrentTabCount = 1;
        sumo.controls.CardView.prototype.dispose.call(this);

    };

    this.PaginateNext = function (aIndex, aNewDataSource, aParam) {        
        mCurrentTab = 'uEnrolleeCorrelateTab' + aIndex;
        mCurrentTabCount = $('#uEnrolleeCorrelateTab' + aIndex).attr('ItemKey');
        mCallBackPar1 = aParam;
        this.setDataSource(aNewDataSource)
    };

    this.getNextTabCount = function (aIndex) {
        var lResults = 0;
        lResults = $('#uEnrolleeCorrelateTab' + aIndex).attr('ItemKey');
        return lResults;
    };

    this.isCurrentTab = function(aIndex){
        var lResult = false,
            lNextTabCount = $('#uEnrolleeCorrelateTab' + aIndex).attr('ItemKey');
       
        if (lNextTabCount == mCurrentTabCount){
            lResult = true;
        }

        return lResult;
    };

    this.setModal = function (isSet) {

        if (isSet == true) {
            $("#" + mThis.Id).find('div[class~="CorrelateModal"]').show();
        } else {
            $("#" + mThis.Id).find('div[class~="CorrelateModal"]').show();
        }

    };

    

};

VeritracksCorrelateControl.prototype = new sumo.controls.ControlBase();
VeritracksCorrelateControl.prototype.constructor = VeritracksCorrelateControl;
VeritracksCorrelateControl.prototype.baseClass = sumo.controls.ControlBase;